import React, { Component } from "react";
import styled from "styled-components";
import { FlexBox } from "js/react/components/LayoutGrid";
import { BlueButton } from "js/react/components/UiComponents";
import { ThemeProvider } from "@material-ui/styles";
import theme from "js/react/materialThemeOverrides";
import { Gap20 } from "js/react/components/Gap";
import { ExportToPPT } from "js/exporter/exportToPPT";
import { app } from "js/namespaces";

const Container = styled.div`
  height:100%;
  width: 100%;
`;

export class SlideDemoMenu extends Component {
    handleExportToPPTX = () => {
        const exporter = new ExportToPPT();
        exporter.export({ slideCanvases: [app.currentCanvas], debug: event.shiftKey });
    }

    render() {
        return (
            <ThemeProvider theme={theme}>
                <FlexBox fill>
                    <BlueButton>Export to PDF</BlueButton>
                    <Gap20/>
                    <BlueButton onClick={this.handleExportToPPTX}>Export To PPTX</BlueButton>
                    <Gap20/>
                    <BlueButton>Create a Presentation</BlueButton>
                </FlexBox>
            </ThemeProvider>
        );
    }
}
